/** @file Sets a bone's inherit mode; socket bones are refused and a two-bone IK child stays normal. */
import { prim } from '@pose2d/format/doc/schemaParts/primitives';
import { defineCommand } from '../defineCommand';
import { defineSetter } from '../_shared/defineSetter';
import { assertIkChildInherit } from '../_shared/assertIkChildInherit';
import { assertNotSocketBone } from '../_shared/assertNotSocketBone';

const setter = defineSetter({
  domain: 'bone',
  kind: 'bone',
  field: 'inherit',
  schema: prim.inherit,
  description: 'Set how a bone inherits its parent transform: normal, onlyTranslation, noRotationOrReflection, noScale or noScaleOrReflection; the second bone of a two-bone IK must stay normal, and generated socket bones are refused.',
});

/** bone.setInherit: the current mode is a no-op (R2-13); IK_INVALID at `value` for a two-bone IK child left non-normal. */
export const command = defineCommand({
  ...setter,
  apply(draft, input, ctx) {
    const id = ctx.resolve('bone', input.target);
    assertNotSocketBone(draft, id);
    if (draft.bones[id]?.inherit === input.value) return;
    assertIkChildInherit(draft, id, input.value, input.target);
    setter.apply(draft, input, ctx);
  },
});
